module.exports = __webpack_public_path__ + "static/img/item2.2282034.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/item2.png
// module id = 6upL
// module chunks = 1